module.exports = __webpack_public_path__ + "img/refresh-ccw-01.8063316f.svg";